import React from 'react';
import { Button, Flex, Text, ButtonGroup, useDisclosure } from '@chakra-ui/react';
import { useRevertMerchantTheme } from '@domain/merchants/mutations/useRevertMerchantTheme';
import { useMerchantTheme } from '@domain/merchants/queries/useMerchantTheme';
import { useError } from '@olo-web/utils/common/hooks';
import { useCustomThemeDraftState } from '@olo-web/client-state';
import { ECustomThemeViews } from '@olo-web/types/enums';
import { label } from '../constants';

export const RevertToDefaultButton = () => {
  const callError = useError();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate, isLoading } = useRevertMerchantTheme({
    onSuccess: onClose,
    onError: (error) => callError({ error, toastError: true, title: 'Unable to revert theme' }),
  });
  const { data: merchantTheme } = useMerchantTheme();
  const { view } = useCustomThemeDraftState();

  const handleRevert = () => {
    mutate({
      docId: merchantTheme!.id ?? '',
      field: view,
    });
  };

  const isImage =
    view === ECustomThemeViews.LOGO ||
    view === ECustomThemeViews.BACKGROUND_IMAGE ||
    view === ECustomThemeViews.FAVICON;

  return (
    <Flex w="100%" align="center" justify="space-between">
      {isOpen ? (
        <>
          <Text textStyle="p">
            <b>This action is irreversible.</b>
            <br /> Are you sure you want to continue?
          </Text>
          <ButtonGroup ml={4} size="sm">
            <Button
              variant="solid"
              colorScheme="danger"
              onClick={handleRevert}
              isLoading={isLoading}
            >
              {isImage ? 'Delete' : 'Revert'}
            </Button>
            <Button variant="tertiary" colorScheme="blackAlpha" onClick={onClose}>
              Cancel
            </Button>
          </ButtonGroup>
        </>
      ) : (
        <Button variant="outline" size="lg" colorScheme="danger" onClick={onOpen} w="100%">
          {isImage ? 'Delete ' : 'Revert '}
          {!!view && label[view]}
          {isImage ? '' : ' to default theme'}
        </Button>
      )}
    </Flex>
  );
};
